<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Restrictions</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form" autocomplete="off" *ngIf="true != loading">
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Restriction</label>
                    <p-multiSelect [options]="personRestrictionItems" name="availableRestrictions" formControlName="availableRestrictions"></p-multiSelect>
                    <control-validation-messages control="availableRestrictions"></control-validation-messages>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Description</label>
                    <input class="mvd_form-control" type="text" name="restrictionDescription" formControlName="restrictionDescription"/>
                    <control-validation-messages control="restrictionDescription"></control-validation-messages>
                </div>
            </div>
        </fieldset>
    </form>    
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="false == form?.valid || !data.customerNumberId || data.customerNumberId < 1" [isLoading]="saving" btnText="Save" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>